module.exports = __webpack_public_path__ + "static/screely-1579465559231-9c922bc8325d1d6723b2d3cd7d1c27ff.png";